export enum AssignmentStatus {
  Assigned = 1,
  Started = 2,
  Completed = 3,
  Expired = 4
}